import React from 'react';
import {FormattedMessage} from "react-intl";
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {results} from '../../../_common/constants/results';

export function ResultColumnFormatter(cellContent) {
  const prefix = 'users-actions-result-type';
  const getResultType = (result) => {
    switch (result) {
      case results.SUCCESS: return (
        <div className={'font-weight-bolder font-size-lg text-nowrap'} style={{color: '#28a745'}}>
          <img
            src={toAbsoluteUrl('/media/svg/Check.svg')}
            alt="success"
            className={'mr-2'}
          />
          <FormattedMessage id={`${prefix}-success`} defaultMessage="Success"/>
        </div>
      )
      case results.FAIL: return (
        <div className={'font-weight-bolder font-size-lg text-nowrap'} style={{color: '#dc3545'}}>
          <img
            src={toAbsoluteUrl('/media/svg/Cross.svg')}
            alt="fail"
            className={'mr-2'}
          />
          <FormattedMessage id={`${prefix}-fail`} defaultMessage="Fail"/>
        </div>
      )
      default: return null
    }
  };

  return getResultType(cellContent);
}
